import type { MsAdlActivityLabels } from "../en-GB/msAdlCopy";

export const msAdlCopyEs: MsAdlActivityLabels = {
    Walking: "Caminar",
    Cooking: "Cocinar",
    Driving: "Conducir",
    Shopping: "Compras",
    Work: "Trabajo",
    Sport: "Deporte",
    Housework: "Tareas domésticas",
    Socialising: "Vida social",
};
